import BaseApi from '@/api/Base/BaseApi'
import { ModelRetrainEvaluationNodeInfo, UpdateModelRetrainEvaluationNodePayload } from '@/api/ModelRetrainEvaluationNode/types'

const ROOT = '/model-retrain-evaluation'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'asc',
  sortKey: 'datasetItemId',
}

export default class ModelRetrainEvaluationNodeApi extends BaseApi {
  getModelRetrainEvaluationNodeDetail(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<ModelRetrainEvaluationNodeInfo>(`${ROOT}/${modelRetrainEvaluationNodeId}`)
  }

  exportModel(payload: any) {
    const { modelRetrainEvaluationNodeId, isExportNewModel } = payload
    return this.agent.post(`${ROOT}/${modelRetrainEvaluationNodeId}/export`, { isExportNewModel })
  }
  //
  // downloadModel(jobId: string) {
  //   return this.agent.post(`${ROOT}/${jobId}/download`)
  // }

  updateModelRetrainEvaluationNode(payload: UpdateModelRetrainEvaluationNodePayload) {
    const { modelRetrainEvaluationNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainEvaluationNodeId}`, { ...rest, name: name?.trim() })
  }

  getSelectedCheckpoint(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<any>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-checkPoint`)
  }

  getSelectedTasks(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<any>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-tasks`)
  }

  postModelRetrainEvaluationNodeSelectedTasks(payload: any) {
    const { modelRetrainEvaluationNodeId, ...rest } = payload
    return this.agent.post<any>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-tasks`, rest)
  }
}
